export default function delay (ms:number) {
  //  TODO check wth this rule means
  // eslint-disable-next-line promise/param-names
  return new Promise(res => setTimeout(res, ms))
}
